import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FaDownload, FaTimes } from 'react-icons/fa';
import { useInstall } from '../../../context/InstallContext';
import './InstallPrompt.css';

const DISMISS_KEY = 'pwa-install-dismissed';

function InstallPrompt() {
    const { t } = useTranslation();
    const { canInstall, promptInstall } = useInstall();
    const [dismissed, setDismissed] = useState(() => !!sessionStorage.getItem(DISMISS_KEY));

    const handleInstall = useCallback(async () => {
        await promptInstall();
    }, [promptInstall]);

    const handleDismiss = useCallback(() => {
        setDismissed(true);
        sessionStorage.setItem(DISMISS_KEY, 'true');
    }, []);

    if (!canInstall || dismissed) return null;

    return (
        <div className="install-prompt">
            <div className="install-prompt-content">
                <FaDownload className="install-prompt-icon" />
                <div className="install-prompt-text">
                    <strong>{t('installPrompt.title')}</strong>
                    <span>{t('installPrompt.description')}</span>
                </div>
            </div>
            <div className="install-prompt-actions">
                <button className="install-prompt-btn" onClick={handleInstall}>
                    {t('installPrompt.install')}
                </button>
                <button className="install-prompt-close" onClick={handleDismiss} aria-label={t('installPrompt.dismiss')}>
                    <FaTimes />
                </button>
            </div>
        </div>
    );
}

export default InstallPrompt;
